/**
 * P6 / PBIX-style timescale: day (Sunday week-start), month, year.
 * Used by Fabrication Histogram and the Resource Histogram tick.
 */

export const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function parseChartDate(value) {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  const q = raw.match(/^(\d{4})-Q([1-4])$/i);
  if (q) {
    const year = Number(q[1]);
    const quarter = Number(q[2]);
    return {
      date: new Date(year, (quarter - 1) * 3, 1, 12, 0, 0),
      kind: 'quarter',
      quarter,
    };
  }
  const ym = raw.match(/^(\d{4})-(\d{2})$/);
  if (ym) {
    return {
      date: new Date(Number(ym[1]), Number(ym[2]) - 1, 1, 12, 0, 0),
      kind: 'month',
    };
  }
  const d = new Date(`${raw.slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return { date: d, kind: 'week' };
}

export function describeTimeTick(value, index = 0) {
  const parsed = parseChartDate(value);
  if (!parsed) return null;
  const { date: d, kind, quarter } = parsed;
  if (kind === 'week') {
    const day = d.getDate();
    const firstOfMonth = day <= 7;
    return {
      kind,
      top: String(day),
      mid: MONTH_SHORT[d.getMonth()],
      bot: String(d.getFullYear()),
      showMid: index === 0 || firstOfMonth,
      showBot: index === 0 || (firstOfMonth && d.getMonth() === 0),
    };
  }
  if (kind === 'month') {
    return {
      kind,
      top: MONTH_SHORT[d.getMonth()],
      mid: String(d.getFullYear()),
      bot: '',
      showMid: index === 0 || d.getMonth() === 0,
      showBot: false,
    };
  }
  return {
    kind,
    top: `Q${quarter}`,
    mid: String(d.getFullYear()),
    bot: '',
    showMid: index === 0 || quarter === 1,
    showBot: false,
  };
}

export function formatTimeAxisTooltip(value) {
  const parsed = parseChartDate(value);
  if (!parsed) return String(value || '');
  const { date: d, kind, quarter } = parsed;
  if (kind === 'week') {
    const day = d.getDate();
    const month = MONTH_SHORT[d.getMonth()];
    const year = d.getFullYear();
    return d.getDay() === 0
      ? `Sunday ${day} ${month} ${year}`
      : `Week of ${day} ${month} ${year}`;
  }
  if (kind === 'month') return `${MONTH_SHORT[d.getMonth()]} ${d.getFullYear()}`;
  return `Q${quarter} ${d.getFullYear()}`;
}

export function timeAxisHeight(grain = 'week') {
  return grain === 'week' ? 52 : 40;
}
